import { render, staticRenderFns } from "./changePhone.vue?vue&type=template&id=2e5e8a0b&scoped=true"
import script from "./changePhone.vue?vue&type=script&lang=js"
export * from "./changePhone.vue?vue&type=script&lang=js"
import style0 from "./changePhone.vue?vue&type=style&index=0&id=2e5e8a0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5e8a0b",
  null
  
)

export default component.exports